// app/src/features/settings/SettingsHost.jsx
import React from "react";
import AccountModal from "../../components/AccountModal.jsx";
import SettingsModal from "./components/SettingsModal.jsx";

/**
 * The Settings and Account popovers, rendered inside `AppFrame`'s `shareDialog` slot (after the
 * tip layer, desktop-only — the frame renders the slot on its desktop branch alone) exactly where
 * the two inline mounts sat. Each mounts only while its flag is set, so a fresh open is a fresh
 * mount (the account popover counts its `account.open` on mount).
 *
 * `ctx` is the frame context (`proOpen`, `accountOpen`); `settings` and `account` are `AppInner`'s
 * `settingsCtx` / `accountCtx`, the modals' own contexts, passed through untouched — the host hands
 * `ctx` nowhere.
 */
export default function SettingsHost({ ctx, settings, account }) {
  const { proOpen, accountOpen } = ctx;
  return (
    <>
      {proOpen && <SettingsModal ctx={settings} />}
      {accountOpen && <AccountModal ctx={account} />}
    </>
  );
}
